/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingnamerequired2Inputs */

const en_listingnamerequired2 = /** @type {(inputs: Listingnamerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing name is required`)
};

const de_listingnamerequired2 = /** @type {(inputs: Listingnamerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Orts fehlt`)
};

/**
* | output |
* | --- |
* | "Listing name is required" |
*
* @param {Listingnamerequired2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingnamerequired2 = /** @type {((inputs?: Listingnamerequired2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingnamerequired2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingnamerequired2(inputs)
	return de_listingnamerequired2(inputs)
});
export { listingnamerequired2 as "listingNameRequired" }